import { useMemo } from 'react';
import { FUND_ROW_NUMBER } from 'common/constants/fund-ownership';
import UseFundOwnershipFundCellProps from './useFundOwnershipFundCell.props';

const useFundOwnershipFundCell = ({ cells, cell, fundList }: UseFundOwnershipFundCellProps) => {
  const fund = useMemo(() => {
    const fundCell = cells[`${cell.columnLegend}${FUND_ROW_NUMBER}`];
    return fundList?.find(fundListItem => fundListItem.id?.toString() === fundCell.value?.toString());
  }, [fundList, cells, cell]);
  return fund;
};
export default useFundOwnershipFundCell;
